import { NgModule } from '@angular/core';
import { AngularFireStorage } from './storage';

@NgModule({
  providers: [ AngularFireStorage ]
})
export class AngularFireStorageModule { }
